const { h, render, Component } = require('preact');
const SpinnerView = require('../../views/common/spinner')

class OrdersList extends Component {
  constructor(props) {
      super(props);
  }

  render() {
    return (
      <div class = "row select-order-menu">
        <div class="row order-listing">
          <div id="orderContent">
            <div id="ordersTablewrapper" data-bhw="web2018_orders_listing">
              <table width="100%" class="scrollableTable">
                <tbody id="ordersTable">
                  {this.props.itemsTable()}
                </tbody>
              </table>
              {this.props.isLoadingInProgress?<SpinnerView/>:null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = OrdersList
